import React from "react";

function CalendarLegend() {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 mt-4">
      <h3 className="text-gray-900 mb-2 text-sm">Control Types</h3>
      <p className="text-gray-500 text-xs mb-3">Color legend for calendar events</p>
      <div className="flex gap-3 flex-wrap">
        <span className="px-3 py-1.5 rounded text-xs pill-blue">Preventive</span>
        <span className="px-3 py-1.5 rounded text-xs pill-purple">Detective</span>
        <span className="px-3 py-1.5 rounded text-xs pill-orange">Corrective</span>
        <span className="px-3 py-1.5 rounded text-xs pill-green">Directive</span>
      </div>
    </div>
  );
}

export default CalendarLegend;



